import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import {
  Row,
  Col,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  CardBody,
  Card,
  Collapse,
  // UncontrolledTooltip,
  // UncontrolledTooltip,
  // CustomInput,
} from 'reactstrap';
import { FaRegStar, FaStar } from 'react-icons/fa';

import { Flip, toast } from 'react-toastify';
import { Form } from '@unform/web';
import * as Yup from 'yup';
// import { format } from 'date-fns';
import Input from '~/components/Inputs/Input';

import api from '~/services/api';

import UnifyDeliveriesModal from '~/components/Modals/UnifyDeliveriesModal';
// import { setStock, setTemporaryStore } from '~/store/modules/cart/actions';
import ConfirmPickupModal from '~/components/Modals/ConfirmPickupModal';

import PageHeader from '~/components/Common/PageHeader';
import CartMainInfoCard from '~/components/CartDetailsComponents/Cards/CartMainInfoCard';
import ProductsListCard from '~/components/CartDetailsComponents/Cards/ProductsListCard';
import FinalValueCard from '~/components/CartDetailsComponents/Cards/FinalValueCard';
import CartManagementButtons from '~/components/CartDetailsComponents/CartManagementButtons';
import ConsultantManagementButtons from '~/components/CartDetailsComponents/ConsultantManagementButtons';
import {
  useCorreiosReverse,
  CorreiosReverseModal,
  CorreiosReverseInfoCard,
} from '~/components/CartDetailsComponents/CorreiosReverse';
import {
  formatCustomer,
  formatPayment,
  formatProducts,
  formatCart,
} from '~/objectFormatters/Sale';
import SaleStatusBadge from '~/components/SaleStatusBadge';
import { LG } from '~/util/breakpointWidths';
import Loading from '~/components/Loading';
import { getRole } from '~/util/getRole';
import useRoles from '~/hooks/useRoles';
// import GiftBoxesCard from '~/components/CartDetailsComponents/Cards/GiftBoxesCard';
// import TimePicker from '~/components/TimePicker';
// import DatePicker from '~/components/DatePicker';
// import TaxCuponsCard from '~/components/CartDetailsComponents/Cards/TaxCuponsCard';
import CuponsNumberCard from '~/components/CartDetailsComponents/Cards/CuponsNumberCard';
import LossCheckboxCard from '~/components/CartDetailsComponents/Cards/HadLossCheckbox';
import RatingDeliveryModal from '~/components/Modals/RatingModal';
import {
  capitalize,
  formatWhatsappPhoneNumber,
  formatPrice,
} from '~/util/format';
import {
  ARRIVED_AT_CLIENT,
  ARRIVED_AT_STORE,
  CANCELLED,
  DELIVERED,
  GOING_TO_CLIENT,
  GOING_TO_STORE,
  RETURNING_TO_STORE,
  RETURNED_TO_STORE,
  SEARCHING,
} from '~/util/deliveryStatuses';
import { getDeliveryVehicleLabel } from '~/util/deliveryVehicle';
import { getFleetLabel } from '~/util/deliveryFleets';
import CustomerDataCard from '~/components/CartDetailsComponents/Cards/CustomerDataCard';
import MobileHeader from '~/components/HorizontalLayout/Header/MobileHeader';
import PaymentCard from '~/components/CartDetailsComponents/Cards/PaymentCard';
import IconButton from '~/components/IconButton';
import PickupValidationAlert from '~/components/PickupValidation/PickupValidationAlert';
import PickupValidationModal from '~/components/PickupValidation';
import { setAsRescheduled } from '~/store/modules/sales/actions';
// import { setAsRescheduled } from '~/store/modules/sales/actions';
import { useLocalStorage } from '~/hooks/useLocalStorage';
import { SaleMessageBadge } from '~/components/SaleStatusBadge/SaleMessageBadge';
import WhatsappTimeline from '~/components/Whatsapp/WhatsappTimeline';
import InputSelect from '~/components/Inputs/InputSelect';
import ApiOriginInfoCard from '~/components/CartDetailsComponents/Cards/ApiOriginInfoCard';
import ChangeCarrierModal from '~/components/ChangeCarrierModal';
import BoostIncentiveModal from '~/components/BoostIncentiveModal';
import DeliveryHistoryCard from '~/components/CartDetailsComponents/Cards/DeliveryHistoryCard';
import DeliveryQrcode from './DeliveryQrcode';
import ColectDeliveryForm from './ColectDeliveryForm';
import PaymentSuitcaseForm from './PaymentSuitcaseForm';
import { PickupValidationCard } from './PickupValidationCard';
import {
  DeliveryInfoCard,
  CorreiosInfoCard,
  ColectInfoCard,
  AntifraudViddyCard,
  AntifraudInfoCard,
  PaymentInfoCard,
  BillingInfoCard,
  defineDeliveryStatusColor,
} from './DeliveryInfoCard';

const TimerDisplay = ({ timestamp, totalTime }) => {
  const remainingMs = Math.max(totalTime - timestamp, 0);
  const totalSeconds = Math.ceil(remainingMs / 1000);

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, '0');

  return (
    <span
      className="text-secondary font-size-10"
      style={{ position: 'absolute', right: '0.5rem' }}
    >
      <i className="far fa-clock" style={{ marginRight: '1.5rem' }} />
      <span>{minutes > 0 ? `${minutes}:${seconds}` : `${seconds}s`}</span>
    </span>
  );
};

const Sale = ({ match }) => {
  const toastID = useRef(null);

  const roles = useSelector(({ user }) => user.profile.roles);

  const role = useMemo(
    () =>
      getRole(roles, [
        'administrator',
        'digital-consultant',
        'cross-manager',
        'salesman',
        'store-manager',
        'financier',
      ]),
    [roles]
  );

  const { isConsultant, isSupport } = useRoles();
  const isUserSupport = useMemo(() => Boolean(isSupport), [isSupport]);

  const subscriberId = localStorage.getItem('@VIDDY:X-Server');
  const subscriberViddyComercial = '504c2f33-f3af-411c-b6f4-c9c483f8b745';

  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();

  const formRef = useRef(null);

  const cuponsformRef = useRef(null);

  const [sale, setSale] = useState(null);
  const [products, setProducts] = useState(null);
  const [fee, setFee] = useState(null);

  const [client, setClient] = useState(null);
  const [unifiableCarts, setUnifiableCarts] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [cartsToUnify, setCartsToUnify] = useState([]);

  const [loading, setLoading] = useState(true);
  const [loadingInformation, setLoadingInformation] = useState(true);
  const [showUnifyDeliveriesModal, setShowUnifyDeliveriesModal] =
    useState(false);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [isCancelDeliveryModalOpen, setIsCancelDeliveryModalOpen] =
    useState(false);
  const [isFinishCancelledOrderModalOpen, setIsFinishCancelledOrderModalOpen] =
    useState(false);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [modalDismissedManually, setModalDismissedManually] = useState(false);
  const hasOpenedModal = useRef(false);
  // const [isRetryDeliveryModalOpen, setIsRetryDeliveryModalOpen] =
  //   useState(false);

  // const [deliveryNow, setDeliveryNow] = useState(true);
  // const [scheduledDeliveryDate, setScheduledDeliveryDate] = useState(null);
  // const [scheduledDeliveryTime, setScheduledDeliveryTime] = useState(null);

  const [delivery, setDelivery] = useState(null);
  const [shouldReloadCart, setShouldReloadCart] = useState(true);
  // const [prevStatus, setPrevStatus] = useState(null);

  const [isDceWarningOpen, setIsDceWarningOpen] = useState(false);
  const [isNfeDeclarationInfoOpen, setIsNfeDeclarationInfoOpen] =
    useState(false);
  // Pré-postagem a que o contador de polls pertence
  const labelPollKeyRef = useRef(null);

  const [isCorreiosLabelModalOpen, setIsCorreiosLabelModalOpen] =
    useState(false);
  const [isGeneratingLabel, setIsGeneratingLabel] = useState(false);

  const [labelStatus, setLabelStatus] = useState('idle'); // idle | pending | processing | ready | failed
  // eslint-disable-next-line no-unused-vars
  const [labelS3Url, setLabelS3Url] = useState(null);
  const [labelTrackingCode, setLabelTrackingCode] = useState(null);
  const [labelError, setLabelError] = useState(null);
  const [isRetryingLabel, setIsRetryingLabel] = useState(false);

  const [invoiceKeyFocusRequest, setInvoiceKeyFocusRequest] = useState(0);

  const [pickupValidationEnabled, setPickupValidationEnabled] = useState(false);

  // Ref para controlar o interval do polling
  const labelPollingRef = useRef(null);
  // Contador de execuções do polling — limite para nunca poll-ar infinitamente
  const labelPollCountRef = useRef(0);
  const MAX_LABEL_POLLS = 45; // 45 x 8s = ~6 minutos

  const [isDownloadingDeclaration, setIsDownloadingDeclaration] =
    useState(false);
  // const [isCorreiosDeclarationModalOpen, setIsCorreiosDeclarationModalOpen] = useState(false);
  // const [declarationHtml, setDeclarationHtml] = useState('');

  const [shareableURL, setShareableURL] = useState(null);
  const [shouldShowColectDeliveryForm, setShouldShowColectDeliveryForm] =
    useState(null);
  const [shouldShowPaymentSuitcaseform, setShouldShowPaymentSuitcaseform] =
    useState(null);
  // const [shareablePix, setShareablePix] = useState(null);

  const [isDownloadingRefundReceipt, setIsDownloadingRefundReceipt] =
    useState(false);

  const [showChangeCarrier, setShowChangeCarrier] = useState(false);
  const [showBoostIncentive, setShowBoostIncentive] = useState(false);

  const params = location.state?.params;

  const { id } = match.params;

  const invoiceKey = sale?.nfce?.key || null;
  const fiscalDocument = delivery?.metadata?.fiscal?.document || null; // 'NFE' | 'DCE'
  const isPrePostagemCanceled =
    sale?.delivery_method === 'CORREIOS' && delivery?.status === CANCELLED;

  const windowSize = useSelector(({ layout }) => layout.windowSize);
  const showSidebar = useSelector(({ layout }) => layout.windowSize);

  const [statusDataCardExpand, setStatusDataCardExpand] = useState(true);

  const showButtons = useMemo(() => {
    if (windowSize < LG) {
      return true;
    }
    return false;
  }, [windowSize]);

  const hideButtonSaleCross = useMemo(
    () =>
      (sale?.status >= 2 && sale?.is_cross && role === 'digital-consultant') ||
      (sale?.is_cross &&
        sale?.status_text === 'Aguardando aceite' &&
        role === 'cross-manager'),
    [sale, role]
  );

  /* const showGiftBoxesCard = useMemo(
    () => products?.some(p => p.pivot.gift),
    [products]
  ); */

  const setData = cart => {
    const formattedSale = formatCart(cart);
    setSale(formattedSale);
  };

  const setProductsData = productsArr => {
    const formattedProducts = formatProducts(productsArr);
    setProducts(formattedProducts);
  };

  const loadSale = useCallback(async () => {
    const loadDelivery = async () => {
      try {
        const { data } = await api.get(`${role}/carts/${id}/delivery`);

        if (data) {
          setDelivery(data.delivery);
          // setPrevStatus(data.delivery?.status);
        }
      } catch (err) {
        if (err.response && err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        }
      }
    };

    const {
      data: { cart },
    } = await api.get(`${role}/carts/${id}`);

    if (cart) {
      if (
        !(cart?.status === 0 && cart.is_shareable) ||
        cart.is_payment_checkout
      ) {
        if (
          cart?.status >= 3 &&
          cart.is_for_delivery &&
          [
            'BEE',
            'MOTTU',
            'UBER',
            'CORREIOS',
            'CORREIOS_EXPRESS',
            'VIDDY_DELIVERIES',
            'LALAMOVE',
            'ENTREGA99',
            'IFOOD_ENVIOS',
            'PROPRIA',
          ].includes(cart.delivery_method)
        ) {
          await loadDelivery();
        }

        if (
          [
            'BEE',
            'MOTTU',
            'UBER',
            'CORREIOS',
            'CORREIOS_EXPRESS',
            'VIDDY_DELIVERIES',
            'LALAMOVE',
            'ENTREGA99',
            'IFOOD_ENVIOS',
            'PROPRIA',
          ].includes(cart.delivery_method)
        ) {
          const {
            data: { alerts: alertsList },
          } = await api.get(`${role}/carts/${id}/alerts`);

          setAlerts(alertsList);
          const unifiableAlert = alertsList.filter(
            a => a.type === 'CARTS_WITH_CLOSE_DESTINATION'
          );

          const unifiableCartsList = unifiableAlert[0]?.carts.map(c => ({
            ...c,
            checked: false,
          }));

          setUnifiableCarts(unifiableCartsList);
        }

        // if (cart?.status !== 6 && cart?.status >= 1 && cart.is_for_delivery) {
        //   const { data } = await api.get(
        //     `${
        //       isStoreManager ? 'store-manager' : 'salesman'
        //     }/carts/${id}/delivery/freight`
        //   );

        //   setFreight(data.freight);
        // }

        if (cart?.status > 0 && cart.payment_process) {
          const { data } = await api.get(`${role}/carts/${id}/payment`);

          const formattedFee = formatPayment(data);
          setFee(formattedFee);
        }

        if (cart.client) {
          try {
            const {
              data: { client: customer },
            } = await api.get(`clients/${cart?.client?.id}`);

            const formattedCustomer = formatCustomer(customer);

            setClient(formattedCustomer);
          } catch (err) {
            if (err.response && err?.response?.data?.message) {
              toast.error(err?.response?.data?.message);
            } else {
              toast.error('Ocorreu um erro ao carregar o cliente');
            }
          }
        }
      }
      setProductsData(cart.products);
      setData(cart);

      if (cart.is_shareable && cart?.status !== 6) {
        setShareableURL(cart?.url_shortener?.url);
      }
      setShouldReloadCart(false);
    }
  }, [role, id]);

  // Devolução pelos Correios (logística reversa)
  const correiosReverse = useCorreiosReverse(sale, loadSale);

  const toggleCorreiosLabelModal = () => {
    setIsCorreiosLabelModalOpen(prev => !prev);
  };

  const handleOpenCorreiosLabelModal = () => {
    if (!invoiceKey) {
      setIsDceWarningOpen(true);
      return;
    }

    toggleCorreiosLabelModal();
  };

  const handleGenerateCorreiosLabel = async () => {
    try {
      labelPollCountRef.current = 0;
      setIsGeneratingLabel(true);
      setLabelStatus('idle');
      setLabelS3Url(null);
      setLabelError(null);

      const { data } = await api.post(`/correios/prepostagem`, {
        cart_id: sale.id,
      });

      const payload = data?.data || data;
      const trackingCode = payload?.codigo_objeto || null;
      const status = payload?.label_status || 'pending';

      setLabelTrackingCode(trackingCode);

      // ─── CASO 1: Rótulo gerou de imediato (síncrono) ───
      if (status === 'ready') {
        // Prioriza S3 URL, senão usa pdf_base64
        if (payload?.s3_url) {
          setLabelS3Url(payload.s3_url);
        } else if (payload?.pdf_base64) {
          // Fallback: cria blob URL a partir do base64
          const base64Clean = payload.pdf_base64.includes(',')
            ? payload.pdf_base64.split(',')[1]
            : payload.pdf_base64;
          const byteCharacters = atob(base64Clean);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i += 1) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          setLabelS3Url(url);
        }

        setLabelStatus('ready');
        toast.success('Pré-postagem e etiqueta geradas com sucesso!');
      } else {
        // ─── CASO 2: Rótulo pendente (assíncrono, polling vai buscar) ───
        setLabelStatus(status);
        toast.success('Pré-postagem criada! Gerando etiqueta...');
      }

      await loadSale();
    } catch (err) {
      console.error(err);
      setLabelStatus('idle');
      toast.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          err?.message ||
          'Não foi possível criar a pré-postagem nos Correios.'
      );
    } finally {
      setIsGeneratingLabel(false);
    }
  };

  const pollLabelStatus = async () => {
    if (!sale?.id) return;

    labelPollCountRef.current += 1;

    if (labelPollCountRef.current > MAX_LABEL_POLLS) {
      if (labelPollingRef.current) {
        clearInterval(labelPollingRef.current);
        labelPollingRef.current = null;
      }
      setLabelStatus('failed');
      setLabelError(
        'Tempo limite excedido ao gerar a etiqueta. Tente novamente.'
      );
      return;
    }

    try {
      const { data } = await api.get(`/correios/prepostagem/${sale.id}/rotulo`);

      const payload = data?.data || data;
      const status = payload?.status || 'pending';

      setLabelStatus(status);

      if (payload?.tracking_code) {
        setLabelTrackingCode(payload.tracking_code);
      }

      if (status === 'ready') {
        setLabelError(null);
        toast.success('Etiqueta gerada com sucesso!');
      }

      if (status === 'failed') {
        setLabelError(
          payload?.last_error || 'Não foi possível gerar a etiqueta.'
        );
      }
    } catch (err) {
      console.error('Erro ao consultar status do rótulo:', err);
    }
  };

  const handleRetryLabel = async () => {
    if (!sale?.id) return;

    try {
      setIsRetryingLabel(true);
      setLabelError(null);
      labelPollCountRef.current = 0;

      const { data } = await api.post(
        `/correios/prepostagem/${sale.id}/rotulo/retry`
      );

      const payload = data?.data || data;
      setLabelStatus(payload?.status || 'pending');

      toast.info('Rótulo re-enfileirado. Aguarde...');
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          'Falha ao tentar novamente.'
      );
    } finally {
      setIsRetryingLabel(false);
    }
  };

  /**
   * Download da etiqueta — CORRIGIDO.
   *
   * Agora funciona de 3 formas:
   * 1. Se já tem labelS3Url no state → abre direto
   * 2. Se não tem, consulta a rota /rotulo para pegar a URL do S3
   * 3. Abre a URL em nova aba (o S3 entrega o PDF direto)
   */
  const handleDownloadCorreiosLabel = async () => {
    if (!sale?.id) return;

    try {
      // Chama endpoint que retorna o PDF direto do S3
      const response = await api.get(
        `/correios/prepostagem/${sale.id}/rotulo/download`,
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = `etiqueta-correios-${
        sale?.order_number || sale?.id || 'pedido'
      }.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);

      if (err?.response?.status === 202) {
        toast.info('A etiqueta ainda está sendo gerada. Aguarde...');
      } else {
        toast.error('Erro ao baixar a etiqueta.');
      }
    }
  };

  useEffect(() => {
    if (
      sale &&
      !sale.is_for_delivery &&
      sale.confirmation_code &&
      !hasOpenedModal.current &&
      !modalDismissedManually &&
      sale.status_text === 'Encaminhado por estoquista'
    ) {
      setShowConfirmationModal(true);
      hasOpenedModal.current = true;
    }
  }, [sale, modalDismissedManually]);

  useEffect(() => {
    if (!shouldReloadCart) return;

    document.title = 'Venda | Viddy';

    setLoading(true);
    loadSale()
      .then(() => setLoading(false))
      .catch(e => {
        console.error(e);
        setLoading(false);
        toast.error('Não foi possível carregar as informações dessa venda.');
        history.push({
          pathname: '/',
          state: { ...params },
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadSale, shouldReloadCart]);

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      if (sale?.status === 4) return;
      if (sale?.status === 6) return;
      if (sale?.status === 9) return;
      if (sale?.status === 12) return;
      loadSale();
    }, 40 * 1000);

    return () => clearInterval(refreshInterval);
  }, [sale, loadSale]);

  useEffect(() => {
    if (
      sale?.is_for_delivery &&
      (sale?.delivery?.status === 'DELIVERED' ||
        sale?.delivery?.status === 'COMPLETED') &&
      !sale?.delivery_score &&
      !sale.return_delivery
    ) {
      setShowRatingModal(true);
    }

    if (
      sale?.is_for_delivery &&
      (sale?.return_delivery?.status === 'DELIVERED' ||
        sale?.return_delivery?.status === 'COMPLETED') &&
      !sale?.return_delivery_score
    ) {
      setShowRatingModal(true);
    }
  }, [sale]);

  useEffect(() => {
    let mounted = true;

    api
      .get('/utils/available-delivery-services')
      .then(({ data }) => {
        if (mounted) {
          setPickupValidationEnabled(Boolean(data?.pickup_validation_enabled));
        }
      })
      .catch(() => {
        if (mounted) setPickupValidationEnabled(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  // useEffect(() => {
  //   let interval;

  //   if (
  //     sale &&
  //     sale.is_for_delivery &&
  //     sale?.status >= 3 &&
  //     sale?.status !== 4 &&
  //     sale?.status !== 6 &&
  //     sale.delivery_method === 'BEE' &&
  //     sale.delivery_address &&
  //     sale.delivery?.status !== 'DELIVERED' &&
  //     sale.delivery?.status !== 'COMPLETED' &&
  //     sale.delivery?.status !== 'CANCELED'
  //   )
  //     interval = setInterval(async () => {
  //       const { data } = await api.get(`${role}/carts/${id}/delivery`);
  //       setDelivery(data.delivery);
  //       setPrevStatus(data.delivery?.status);
  //       if (prevStatus !== data.delivery?.status) {
  //         toast.success('Status de entrega atualizada!', { autoClose: 5000 });
  //       }
  //     }, 5 * 1000);

  //   return () => clearInterval(interval);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [prevStatus, id, sale]);

  const handleFinishCancelledOrder = async data => {
    try {
      formRef.current.setErrors({});

      const schema = Yup.object().shape({
        finalization_reason: Yup.string().required(
          'Selecione o motivo da finalização'
        ),
        finalization_details: Yup.string()
          .trim()
          .min(5, 'A descrição deve ter pelo menos 5 caracteres')
          .required('Insira a descrição detalhada'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      const {
        data: { cart },
      } = await api.patch(`${role}/carts/${id}/finalize`, data);

      setData(cart);
      setIsFinishCancelledOrderModalOpen(false);
      setShouldReloadCart(true);
      toast.success('Venda manualmente marcada como entregue com sucesso!');
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(e => {
          validationErrors[e.path] = e.message;
        });
        formRef.current.setErrors(validationErrors);
      }

      if (err.response?.data?.message) {
        toast.error(err.response.data.message, {
          autoClose: err.response.data.duration || 5000,
        });
      }
    }
  };

  const handleAddToUnifiedCarts = cartId => {
    const alreadyAdded = unifiableCarts.find(cart => cart === cartId);
    if (alreadyAdded) return;

    const draft = unifiableCarts.map(cart =>
      cart.id === cartId ? { ...cart, checked: true } : cart
    );

    setUnifiableCarts(draft);

    setCartsToUnify(
      draft.filter(cart => {
        return cart.checked;
      })
    );
  };

  const handleRemoveFromUnifiedCarts = cartId => {
    const draft = unifiableCarts.map(cart =>
      cart.id === cartId ? { ...cart, checked: false } : cart
    );

    setUnifiableCarts(draft);

    setCartsToUnify(
      draft.filter(cart => {
        return cart.checked;
      })
    );
  };

  const handleUnifyDeliveries = async () => {
    const parentCard = [{ id, order_number: sale.order_number, checked: true }];

    const unifiableCartsList = parentCard
      .concat(unifiableCarts)
      .filter(c => c.checked === true)
      .map(c => c.id);

    if (unifiableCartsList.length === 1) {
      toast.error(
        'Para unificar entregas, se faz necessário dois ou mais carrinhos, incluindo o atual.'
      );
    } else {
      try {
        toastID.current = toast.info('Registrando chamada...', {
          autoClose: false,
        });

        await api.post(`${role}/carts/request-unified-delivery`, {
          carts: unifiableCartsList,
        });

        toast.update(toastID.current, {
          render:
            'Chamada registrada com sucesso para todos os carrinhos! Redirecionando...',
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
          transition: Flip,
        });

        history.push('/');
      } catch (err) {
        toast.update(toastID.current, {
          render: err?.response?.data?.message,
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          transition: Flip,
        });
      }
    }
  };

  const handleAddCuponsNumber = async data => {
    try {
      const { receipt_number } = data;

      cuponsformRef.current.setErrors({});

      const schema = Yup.object().shape({
        receipt_number: Yup.string().required(
          'O número da nota fiscal não pode estar vazio!'
        ),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      if (!receipt_number) {
        toast.error('O número da nota não pode estar vazio!');
        return;
      }

      setLoading(true);

      await api.patch(`${role}/carts/${id}`, {
        nfce: {
          number: receipt_number,
        },
      });

      const {
        data: { cart },
      } = await api.get(`${role}/carts/${id}`);

      setData(cart);

      setLoading(false);

      toast.success('Número da nota fiscal salvo com sucesso!');
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(e => {
          validationErrors[e.path] = e.message;
        });
        cuponsformRef.current.setErrors(validationErrors);
      }

      if (err.response && err?.response?.data?.message) {
        toast.error(err?.response?.data?.message, {
          autoClose: err?.response?.data?.duration || 5000,
        });
      }
    }
  };

  // const handleUploadTaxCoupon = async data => {
  //   try {
  //     if (data !== null) {
  //       setLoading(true);

  //       const formData = new FormData();

  //       formData.append('tax_coupon', data);

  //       await api.post(`${role}/carts/${id}/attach-tax-coupon`, formData);

  //       const {
  //         data: { cart },
  //       } = await api.get(`${role}/carts/${id}`);

  //       setData(cart);

  //       setLoading(false);

  //       toast.success('Cupom fiscal anexado');
  //     } else {
  //       setLoading(true);

  //       await api.post(`${role}/carts/${id}/attach-tax-coupon`, {
  //         tax_coupon: null,
  //       });

  //       const {
  //         data: { cart },
  //       } = await api.get(`${role}/carts/${id}`);

  //       setData(cart);

  //       setLoading(false);

  //       toast.success('Cupom fiscal removido');
  //     }
  //   } catch (err) {
  //     if (err.response && err?.response?.data?.message)
  //       toast.error(err?.response?.data?.message);
  //   }
  // };

  // const handleRetryDelivery = async () => {
  //   try {
  //     setLoading(true);

  //     const date = format(scheduledDeliveryDate, 'dd MMMM yyyy');
  //     const time = format(scheduledDeliveryTime, "HH':'mm'");

  //     const deliveryMoment = new Date(`${date} ${time}`);

  //     const {
  //       data: { delivery: saleRetryDelivery },
  //     } = await api.post(`${role}/carts/${sale.id}/delivery/retry`, {
  //       scheduled_to: deliveryMoment,
  //       force_retry: forceRetry,
  //     });

  //     const {
  //       data: { cart },
  //     } = await api.get(`${role}/carts/${sale.id}`);

  //     setData(cart);

  //     setDelivery(saleRetryDelivery);

  //     setIsRetryDeliveryModalOpen(false);

  //     dispatch(setAsRescheduled());

  //     setLoading(false);

  //     toast.success('Nova tentativa de entrega processada!');
  //   } catch (err) {
  //     setLoading(false);
  //     if (err?.response?.data?.scheduled_to[0])
  //       toast.error(
  //         'O campo de agendar entrega deve ser uma data posterior ou igual a agora'
  //       );
  //     toast.error(err?.response?.data?.message);
  //     if (
  //       err?.response?.data?.message ===
  //       'Não é possível solicitar uma nova tentativa de entrega neste momento. Um entregador já pode estar a caminho.'
  //     ) {
  //       setForceRetry(true);
  //     }
  //   }
  // };

  const [forceRetry, setForceRetry] = useState(false);
  const [dateNow, setDateNow] = useState(0);
  const [lastDeliveryForceRetry, setLastDeliveryForceRetry] = useLocalStorage(
    'last_delivery_force_retry',
    0
  );
  const COOLDOWN_MS = useMemo(
    () => (isUserSupport ? 40000 : 180000),
    [isUserSupport]
  );
  const [shouldDisableDeliveryForceRetry, setShouldDisableDeliveryForceRetry] =
    useState(false);

  useEffect(() => {
    const tick = () => {
      const now = Date.now();
      setDateNow(now);
      setShouldDisableDeliveryForceRetry(
        now < lastDeliveryForceRetry + COOLDOWN_MS
      );
    };

    tick();

    let interval = null;

    if (Date.now() < lastDeliveryForceRetry + COOLDOWN_MS) {
      interval = setInterval(tick, 250);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [lastDeliveryForceRetry, COOLDOWN_MS]);

  const handleRetryDeliveryNow = async () => {
    try {
      if (shouldDisableDeliveryForceRetry) return;

      setLoading(true);

      const now = Date.now();
      setLastDeliveryForceRetry(now);
      setDateNow(now);
      setShouldDisableDeliveryForceRetry(true);

      const {
        data: { delivery: saleRetryDelivery },
      } = await api.post(`${role}/carts/${id}/delivery/retry-force`, {
        force_retry: forceRetry,
      });

      const {
        data: { cart },
      } = await api.get(`${role}/carts/${id}`);

      setData(cart);
      setDelivery(saleRetryDelivery);
      dispatch(setAsRescheduled());

      setLoading(false);
      toast.success('Nova tentativa de entrega processada!');
    } catch (err) {
      setLoading(false);
      if (err.response && err?.response?.data?.message) {
        toast.error(err?.response?.data?.message, {
          autoClose: err?.response?.data?.duration || 5000,
        });
      }
      setForceRetry(true);
    }
  };

  /*
  const handleResetDelivery = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await api.post(`${role}/carts/${id}/delivery/reset`);

      const saleDraft = {
        ...sale,
        delivery: data.delivery,
      };

      setData(saleDraft);

      setDelivery(data.delivery);

      setLoading(false);
      toast.success('Entrega reiniciada, buscando novo entregador!');
    } catch (err) {
      setLoading(false);
      if (err.response && err?.response?.data?.message) {
        toast.error(err?.response?.data?.message, {
          autoClose: err?.response?.data?.duration || 5000,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, sale]);
  */

  const handleCancelDelivery = useCallback(
    async data => {
      try {
        formRef.current.setErrors({});

        const schema = Yup.object().shape({
          reason: Yup.string().required('Insira o motivo do cancelamento'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        setLoading(true);

        const {
          data: { delivery: saleDelivery },
        } = await api.patch(`${role}/carts/${id}/delivery/cancel`, data);

        const saleDraft = {
          ...sale,
          delivery: saleDelivery,
        };

        setData(saleDraft);

        setDelivery(saleDelivery);

        setLoading(false);

        setIsCancelDeliveryModalOpen(false);

        setShouldReloadCart(true);
        toast.success('Entrega cancelada com sucesso!');
      } catch (err) {
        const validationErrors = {};

        setLoading(false);

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach(e => {
            validationErrors[e.path] = e.message;
          });
          formRef.current.setErrors(validationErrors);
        }
        if (err.response && err?.response?.data?.message)
          toast.error(err?.response?.data?.message);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, sale]
  );

  /*
  function base64ToUtf8(base64) {
    const raw = window.atob(base64);
    const bytes = Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
    return new TextDecoder('utf-8').decode(bytes);
  }
  */

  /*
  const handlePrint = () => {
    const iframe = document.getElementById('declaration-frame');
    if (!iframe) return;

    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  };
  */

  /*
  const toggleCorreiosDeclarationModal = () => {
    setIsCorreiosDeclarationModalOpen(prev => !prev);
  };
  */

  /*
  const handleOpenDeclarationModal = async () => {
    try {
      setIsDownloadingDeclaration(true);

      if (!delivery?.id_on_service) {
        toast.error('ID da Pré-postagem não encontrado!');
        return;
      }

      const { data } = await api.get(
        `/correios/declaracao/${delivery.id_on_service}`
      );

      if (!data?.html_base64) {
        toast.error('Resposta inválida da declaração de conteúdo.');
        return;
      }

      const html = base64ToUtf8(data.html_base64);

      setDeclarationHtml(html);
      setIsCorreiosDeclarationModalOpen(true);
    } catch (err) {
      console.error(err);
      toast.error('Erro ao carregar declaração de conteúdo.');
    } finally {
      setIsDownloadingDeclaration(false);
    }
  };
  */

  /**
   * Baixa a DACE (Declaração de Conteúdo Eletrônica) em PDF.
   * Substitui o fluxo antigo de HTML em iframe (declaração em papel),
   * que não é mais aceita pelos Correios.
   *
   * Mantém o nome handleOpenDeclarationModal para não alterar a fiação
   * do botão em ConsultantManagementButtons.
   */
  const handleOpenDeclarationModal = async () => {
    if (fiscalDocument === 'NFE') {
      setIsNfeDeclarationInfoOpen(true);
      return;
    }

    if (!delivery?.id_on_service) {
      toast.error('ID da Pré-postagem não encontrado!');
      return;
    }

    try {
      setIsDownloadingDeclaration(true);

      const response = await api.get(
        `/correios/declaracao/${delivery.id_on_service}`,
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `dace-correios-${
        sale?.order_number || sale?.id || 'pedido'
      }.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      toast.error('Erro ao baixar a DACE (declaração de conteúdo eletrônica).');
    } finally {
      setIsDownloadingDeclaration(false);
    }
  };

  const handleAcceptOrder = async () => {
    try {
      setLoading(true);

      await api.patch(`${role}/carts/${id}/cross/accept`);

      setLoading(false);
      history.push('/');
      toast.success('Pedido aceito!');
    } catch (err) {
      setLoading(false);
      if (err.response && err?.response?.data?.message) {
        toast.error(err?.response?.data?.message, {
          autoClose: err?.response?.data?.duration || 5000,
        });
      }
    }
  };

  const toggle = () => setShowUnifyDeliveriesModal(!showUnifyDeliveriesModal);

  const toggleCancelDelivery = () =>
    setIsCancelDeliveryModalOpen(!isCancelDeliveryModalOpen);

  const toggleFinishCancelledOrder = () =>
    setIsFinishCancelledOrderModalOpen(!isFinishCancelledOrderModalOpen);

  const toggleRating = () => setShowRatingModal(!showRatingModal);

  // const toggleRetryDelivery = () =>
  //   setIsRetryDeliveryModalOpen(!isRetryDeliveryModalOpen);

  const alertsLength = useMemo(() => alerts.length, [alerts]);

  useEffect(() => {
    if (loadingInformation && sale && fee && client) {
      setLoadingInformation(false);
    }
  }, [fee, sale, client, loadingInformation]);

  useEffect(() => {
    return () => {
      if (isConsultant) {
        dispatch(setSale(null));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (labelPollingRef.current) {
      clearInterval(labelPollingRef.current);
      labelPollingRef.current = null;
    }

    if (labelStatus === 'pending' || labelStatus === 'processing') {
      // O contador é por pré-postagem: o refresh da venda a cada 40s não
      // pode reiniciá-lo, senão o limite de 45 polls nunca é atingido.
      const pollKey = delivery?.id_on_service || null;

      if (labelPollKeyRef.current !== pollKey) {
        labelPollKeyRef.current = pollKey;
        labelPollCountRef.current = 0;
      }

      const initialTimeout = setTimeout(() => {
        pollLabelStatus();
      }, 3000);

      labelPollingRef.current = setInterval(() => {
        pollLabelStatus();
      }, 8000);

      return () => {
        clearTimeout(initialTimeout);
        if (labelPollingRef.current) {
          clearInterval(labelPollingRef.current);
          labelPollingRef.current = null;
        }
      };
    }

    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [labelStatus, sale?.id]);

  /**
   * Ao abrir o modal ou ao carregar a venda, sincroniza o label status
   * a partir do delivery metadata.
   */
  useEffect(() => {
    if (isCorreiosLabelModalOpen && sale?.id && delivery) {
      const meta = delivery?.metadata?.label;

      if (delivery?.status === CANCELLED) {
        setLabelStatus('idle');
        setLabelS3Url(null);
        setLabelError(null);
        setLabelTrackingCode(null);
        return;
      }

      if (meta) {
        setLabelStatus(meta.status || 'idle');
        setLabelS3Url(meta.s3_url || null);
        setLabelError(meta.last_error || null);
        setLabelTrackingCode(
          delivery?.track_data || delivery?.metadata?.tracking?.code || null
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCorreiosLabelModalOpen]);

  /**
   * Sincroniza label status quando o delivery carrega/atualiza.
   * Isso garante que os botões FORA do modal reflitam o estado correto.
   */
  useEffect(() => {
    if (delivery?.status === CANCELLED) {
      setLabelStatus('idle');
      setLabelS3Url(null);
      setLabelError(null);
      return;
    }

    if (delivery?.metadata?.label) {
      const meta = delivery.metadata.label;
      setLabelStatus(meta.status || 'idle');
      setLabelS3Url(meta.s3_url || null);
      setLabelError(meta.last_error || null);
    }
    if (delivery?.track_data) {
      setLabelTrackingCode(delivery.track_data);
    }
  }, [delivery]);

  useEffect(() => {
    return () => {
      if (labelPollingRef.current) {
        clearInterval(labelPollingRef.current);
      }
    };
  }, []);

  const formatPhone = phone => {
    if (!/^\d+$/.test(phone)) return phone;
    const ddd = phone.slice(0, 2);
    let first;
    let last;
    if (phone[2] === '9' && phone.length === 11) {
      first = phone.slice(2, 7);
      last = phone.slice(7, 11);
    } else {
      first = phone.slice(2, 6);
      last = phone.slice(6, 10);
    }
    return `(${ddd}) ${first}-${last}`;
  };

  const salePaymentReverse = useCallback(
    async (confirmed, token) => {
      try {
        setLoading(true);

        await api.patch(`/${role}/carts/${sale?.id}/reverse`, {
          action_token: token,
        });

        setLoading(false);
        setShouldReloadCart(true);
        toast.success('Solicitação de estorno enviada!');
      } catch (err) {
        setLoading(false);
        if (err.response && err?.response?.data?.message) {
          toast.error(err?.response?.data?.message, {
            autoClose: err?.response?.data?.duration || 5000,
          });
        }
      }
    },
    [sale?.id, role]
  );

  const handleDownloadRefundReceipt = useCallback(async () => {
    try {
      setIsDownloadingRefundReceipt(true);

      const { data } = await api.get(
        `${role}/carts/${sale?.id}/refund-receipt/download`
      );

      if (!data?.pdf_base64) {
        toast.error(data?.message || 'Comprovante não disponível.');
        return;
      }

      const byteCharacters = atob(data.pdf_base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i += 1) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = data.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('RefundReceipt download error:', err);
      toast.error(
        err?.response?.data?.message || 'Erro ao baixar comprovante de estorno.'
      );
    } finally {
      setIsDownloadingRefundReceipt(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sale?.id, role]);

  const currentHours = new Date().getHours();

  const shouldShowDeliveryAdvices =
    !loading &&
    sale?.is_for_delivery &&
    !sale?.delivery_method === 'CORREIOS' &&
    !sale?.delivery_method === 'CORREIOS_EXPRESS' &&
    sale?.status !== 0 &&
    ((!sale?.delivery &&
      (sale?.payment_process?.status === 'Paid' ||
        sale?.is_suitcase_delivery)) ||
      (sale?.delivery &&
        !sale?.return_delivery &&
        sale?.delivery?.status_text !== 'A caminho do cliente' &&
        sale?.delivery?.status !== 'ARRIVED_AT_DESTINATION' &&
        sale?.delivery?.status !== 'DELIVERED' &&
        sale?.delivery?.status !== 'CANCELED') ||
      (sale?.return_delivery &&
        sale?.return_delivery?.status_text !== 'A caminho da loja' &&
        sale?.return_delivery?.status !== 'ARRIVED_AT_STORE' &&
        sale?.return_delivery?.status !== 'DELIVERED' &&
        sale?.return_delivery?.status !== 'CANCELED') ||
      sale?.status_text === 'Aguardando estoquista');

  const waitTillTomorrowAdvice =
    shouldShowDeliveryAdvices && currentHours >= 19;
  const waitTillCommercialAdvice =
    shouldShowDeliveryAdvices && currentHours <= 8;
  const saleValueAttentionAdvice =
    shouldShowDeliveryAdvices && (Number(sale?.amount) || 0) >= 1500;

  if (shouldShowColectDeliveryForm)
    return (
      <ColectDeliveryForm
        setShouldReloadCart={setShouldReloadCart}
        sale={sale}
        setShouldShowColectDeliveryForm={setShouldShowColectDeliveryForm}
        role={role}
        client={client}
      />
    );

  if (shouldShowPaymentSuitcaseform)
    return (
      <PaymentSuitcaseForm
        sale={sale}
        setShouldShowPaymentSuitcaseform={setShouldShowPaymentSuitcaseform}
        setShouldReloadCart={setShouldReloadCart}
      />
    );

  return (
    <>
      <MobileHeader
        saleDetails
        arrowAction={() => history.push('/')}
        pageTitle="Detalhes do pedido"
      />
      <div className="page-content">
        <Container className="container new-layout wide">
          {!loading && !shouldReloadCart && sale ? (
            <SaleStatusBadge cart={sale} cartDetails mobile />
          ) : null}
          <Row className="d-none d-lg-flex w-100 mx-0">
            <Col xs={3} className="px-0">
              <PageHeader
                pageTitle="Detalhes do pedido"
                responsivePosition="start"
                desktopPosition="start"
                backTo={role === 'financier' ? '/financeiro' : '/'}
                params={params}
              />
            </Col>
            {/* <Col xs={2} className="px-0" align="end">
            {sale?.delivery_method === 'BEE' &&
              sale?.status === 2 &&
              alertsLength !== 0 && (
                <>
                  <UncontrolledTooltip placement="top" target="alertIcon">
                    Alertas
                  </UncontrolledTooltip>
                  <i
                    id="alertIcon"
                    className="las la-exclamation-triangle bx-tada alert-icon my-4 font-size-60"
                    onClick={() =>
                      setShowUnifyDeliveriesModal(!showUnifyDeliveriesModal)
                    }
                    role="button"
                    tabIndex="0"
                    aria-label="Open alert modal"
                  />
                </>
              )}
          </Col> */}
          </Row>
          {/*
          {saleValueAttentionAdvice && (
            <Row className="d-lg-none mx-0 mb-0">
              <SaleMessageBadge
                color="yellow"
                backgroundColor="rgba(236, 161, 32, 0.15)"
                style={{ marginBottom: '0.5rem' }}
              >
                Atenção! Este pedido tem um valor superior a R$ 1.500,00.
                Reforce sua atenção em confirmar a identidade do entregador que
                irá coletar o seu pedido. Qualquer dúvida, comunique o suporte
                logístico do Viddy.
              </SaleMessageBadge>
            </Row>
          )}
          {waitTillTomorrowAdvice && (
            <Row className="d-lg-none mx-0 mb-0">
              <SaleMessageBadge
                color="yellow"
                backgroundColor="rgba(236, 161, 32, 0.15)"
                style={{ marginBottom: '0.5rem' }}
              >
                Atenção! Que tal esperar para amanhã? Entregas muito tarde
                costumam demorar além do esperado.
              </SaleMessageBadge>
            </Row>
          )}
          {waitTillCommercialAdvice && (
            <Row className="d-lg-none mx-0 mb-0">
              <SaleMessageBadge
                color="yellow"
                backgroundColor="rgba(236, 161, 32, 0.15)"
                style={{ marginBottom: '0.5rem' }}
              >
                Atenção! Que tal aguardar às 9 horas? No horário comercial, as
                entregas costumam ser mais rápidas e com menos imprevistos.
              </SaleMessageBadge>
            </Row>
          )}
        */}

          {loading || shouldReloadCart ? (
            <Loading />
          ) : (
            <>
              {sale?.is_for_delivery && sale?.delivery && (
                <>
                  <PickupValidationAlert
                    deliveryStatus={sale?.delivery?.status}
                    featureEnabled={pickupValidationEnabled}
                    cartValidation={sale?.delivery?.pickup_validation}
                    cartId={sale?.id}
                  />
                  <PickupValidationModal cartId={sale?.id} />
                </>
              )}
              {sale?.status_text !== 'Cancelado' && (
                <ConsultantManagementButtons
                  setShouldReloadCart={setShouldReloadCart}
                  salePaymentReverse={salePaymentReverse}
                  sale={sale}
                  delivery={delivery}
                  formRef={cuponsformRef}
                  separated
                  toggleFinishCancelledOrder={toggleFinishCancelledOrder}
                  setShouldShowColectDeliveryForm={
                    setShouldShowColectDeliveryForm
                  }
                  setShouldShowPaymentSuitcaseform={
                    setShouldShowPaymentSuitcaseform
                  }
                  onOpenCorreiosLabelModal={handleOpenCorreiosLabelModal}
                  onOpenCorreiosDeclarationModal={handleOpenDeclarationModal}
                  isDownloadingDeclaration={isDownloadingDeclaration}
                  onDownloadCorreiosLabel={handleDownloadCorreiosLabel}
                  onRetryCorreiosLabel={handleRetryLabel}
                  labelStatus={labelStatus}
                  onOpenCorreiosReverseModal={correiosReverse.openModal}
                />
              )}
              {(saleValueAttentionAdvice ||
                waitTillTomorrowAdvice ||
                waitTillCommercialAdvice) && (
                <Col
                  xs={12}
                  sm={8}
                  className="mr-0 pl-0 pr-2"
                  style={{ marginTop: '-1rem' }}
                >
                  {saleValueAttentionAdvice && (
                    <SaleMessageBadge
                      color="yellow"
                      backgroundColor="rgba(236, 161, 32, 0.15)"
                      style={{ marginBottom: '0.5rem' }}
                    >
                      Atenção! Este pedido tem um valor superior a R$ 1.500,00.
                      Reforce sua atenção em confirmar a identidade do
                      entregador que irá coletar o seu pedido. Qualquer dúvida,
                      comunique o suporte logístico do Viddy.
                    </SaleMessageBadge>
                  )}
                  {waitTillTomorrowAdvice && (
                    <SaleMessageBadge
                      color="yellow"
                      backgroundColor="rgba(236, 161, 32, 0.15)"
                      style={{ marginBottom: '0.5rem' }}
                    >
                      Atenção! Que tal esperar para amanhã? Entregas muito tarde
                      costumam demorar além do esperado.
                    </SaleMessageBadge>
                  )}
                  {waitTillCommercialAdvice && (
                    <SaleMessageBadge
                      color="yellow"
                      backgroundColor="rgba(236, 161, 32, 0.15)"
                      style={{ marginBottom: '0.5rem' }}
                    >
                      Atenção! Que tal aguardar às 9 horas? No horário
                      comercial, as entregas costumam ser mais rápidas e com
                      menos imprevistos.
                    </SaleMessageBadge>
                  )}
                </Col>
              )}
              {sale?.delivery_router &&
                !sale?.return_delivery &&
                sale?.delivery?.status === SEARCHING && (
                  <Col xs={12} sm={8} className="mr-0 pl-0 pr-2">
                    <div
                      className="border rounded p-3 d-flex align-items-center mb-2"
                      style={{ background: '#DBEAFE', borderColor: '#BFDBFE' }}
                    >
                      <i
                        className="las la-clock font-size-24 mr-2"
                        style={{ color: '#1D4ED8' }}
                      />
                      <div
                        className="font-size-14"
                        style={{ color: '#1E3A8A' }}
                      >
                        A previsão de aceite do seu pedido é de até 25 minutos.
                        Se estiver demorando mais que o normal, você pode
                        acionar nosso suporte para obter mais informações.
                      </div>
                    </div>
                  </Col>
                )}
              {[6, 12, 13].includes(sale?.status) && sale?.payment_process && (
                <Row className="w-100 mx-0">
                  <Col lg={8} className="px-0 pr-lg-2">
                    <Card className="new-layout card">
                      <CardBody className="new-layout card-body px-3 py-3">
                        <Row className="w-100 mx-0 justify-content-between d-flex align-items-center">
                          <Col className="pl-0 pr-0">
                            <span className="font-size-14 font-weight-600 text-gray-700">
                              {sale?.status_text === 'Chargeback'
                                ? 'Esta venda recebeu um chargeback'
                                : 'Esta venda foi estornada'}
                            </span>
                            {sale?.cancellation_reason &&
                              sale?.cancellation_reason.includes(
                                'Pagar.me'
                              ) && (
                                <p className="font-size-13 text-gray-600 mb-0 mt-1">
                                  Motivo: {sale.cancellation_reason}
                                </p>
                              )}
                          </Col>
                          <Col className="pl-0 pr-0" xs="auto">
                            <Button
                              className="new-layout-btn main mx-0 font-size-14 d-flex align-items-center"
                              color="info"
                              outline
                              onClick={handleDownloadRefundReceipt}
                              disabled={isDownloadingRefundReceipt}
                            >
                              <i className="las la-file-pdf mr-2 font-size-18" />
                              {isDownloadingRefundReceipt
                                ? 'Gerando...'
                                : 'Comprovante de estorno'}
                            </Button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
              {sale.is_cross &&
                ['cross-manager', 'administrator', 'store-manager'].includes(
                  role
                ) &&
                !sale.cross_accepted &&
                sale.status_text === 'Aguardando aceite' && (
                  <>
                    <Row className="w-100 mx-0 d-none d-lg-flex">
                      <Col className="pr-2 pl-0" lg={8}>
                        <Card className="new-layout card">
                          <CardBody className="new-layout card-body px-3 py-3">
                            <Row className="w-100 mx-0 justify-content-between d-flex align-items-center">
                              <Col className="mr-0 pl-0 pr-0">
                                <span className="font-size-14 font-weight-600">
                                  Clique no botão ao lado para aceitar esse
                                  pedido
                                </span>
                              </Col>
                              <Col className="mr-0 pl-0 pr-0" align="end">
                                <Button
                                  className="new-layout-btn main mx-0 font-size-14 button-sale-action"
                                  color="success"
                                  size="lg"
                                  onClick={handleAcceptOrder}
                                >
                                  <i className="fa fa-check-circle pl-1 mr-2 font-size-14" />
                                  Aceitar pedido
                                </Button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="w-100 mx-0 d-lg-none">
                      <Col className="pr-2 pl-0">
                        <Card className="new-layout card">
                          <CardBody className="new-layout card-body px-3 py-3">
                            <Row className="w-100 mx-0 justify-content-between d-flex align-items-center mb-2">
                              <Col className="mr-0 pl-0 pr-0">
                                <span className="font-size-16 font-weight-600">
                                  Deseja aceitar esse pedido?
                                </span>
                              </Col>
                            </Row>
                            <Row className="w-100 mx-0 justify-content-between d-flex align-items-center">
                              <Col className="mr-0 pl-0 pr-0">
                                <Button
                                  className="new-layout-btn main mx-0 font-size-14 button-sale-action"
                                  color="success"
                                  size="lg"
                                  onClick={handleAcceptOrder}
                                >
                                  <i className="fa fa-check-circle pl-1 mr-2 font-size-14" />
                                  Aceitar pedido
                                </Button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </>
                )}
              <Row className="w-100 mx-0">
                <Col lg={showSidebar ? 8 : 7} className="px-0 pr-lg-2">
                  {((sale?.status >= 3 && sale?.status < 9) ||
                    sale?.status === 0) && (
                    <>
                      {(![
                        'Aguardando envio',
                        'Malinha entregue',
                        'Coleta realizada',
                        'Entregue',
                        'Cancelado',
                        'Aberto',
                      ].includes(sale.status_text) ||
                        (sale.status_text === 'Malinha entregue' &&
                          sale.return_delivery) ||
                        (sale.status_text === 'Entregue' &&
                          sale.return_delivery)) &&
                        !(
                          sale?.status_text === 'Aguardando envio' ||
                          (sale?.status_text === 'Malinha entregue' &&
                            !sale?.return_delivery) ||
                          sale?.status_text === 'Coleta realizada' ||
                          sale?.status === 9 ||
                          sale?.status === 0
                        ) &&
                        sale?.is_for_delivery &&
                        sale?.delivery_method !== 'CORREIOS' &&
                        sale?.delivery_method !== 'CORREIOS_EXPRESS' && (
                          <Card className="new-layout card">
                            <CardBody className="new-layout card-body p-3">
                              <Row
                                className="font-size-16 font-weight-600 text-gray-700 justify-content-between mx-0 px-0 mb-0"
                                click={() => {
                                  setStatusDataCardExpand(
                                    !statusDataCardExpand
                                  );
                                }}
                              >
                                <div className="px-0 mb-0">
                                  {sale?.is_suitcase_delivery &&
                                    sale?.return_delivery &&
                                    'Coleta'}
                                  {!sale?.is_suitcase_delivery &&
                                    sale?.return_delivery &&
                                    'Devolução'}
                                  {!sale?.return_delivery && 'Entrega'}
                                </div>
                                <div className="px-0 mb-0">
                                  <IconButton
                                    icon={`las la-${
                                      statusDataCardExpand
                                        ? 'angle-up'
                                        : 'angle-right'
                                    }`}
                                    click={() => {
                                      setStatusDataCardExpand(
                                        !statusDataCardExpand
                                      );
                                    }}
                                    color="gray-700"
                                  />
                                </div>
                              </Row>
                              <Collapse isOpen={statusDataCardExpand}>
                                {sale?.delivery_router?.status ===
                                  'EXHAUSTED' && (
                                  <Row className="mx-0 mb-0 mt-3">
                                    <Col className="px-0">
                                      <div
                                        className="border rounded p-3 d-flex align-items-center"
                                        style={{
                                          background: '#FEF3C7',
                                          borderColor: '#FDE68A',
                                        }}
                                      >
                                        <i
                                          className="las la-exclamation-triangle font-size-24 mr-2"
                                          style={{ color: '#B45309' }}
                                        />
                                        <div
                                          className="font-size-14"
                                          style={{ color: '#92400E' }}
                                        >
                                          <b>
                                            Nenhuma transportadora aceitou a
                                            entrega.
                                          </b>{' '}
                                          Todas as opções configuradas para a
                                          loja foram tentadas. Troque a
                                          transportadora ou aumente o incentivo
                                          para retomar a busca.
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                )}
                                <Row className="mx-0 mb-0 mt-2">
                                  {sale?.delivery && (
                                    <Col className="mx-0 pl-0" xs={6} lg={3}>
                                      <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                        Loja
                                      </p>
                                      {sale?.store?.fantasy_name}
                                    </Col>
                                  )}
                                  <Col className="mx-0 pl-0" lg={3}>
                                    <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                      Endereço de coleta
                                    </p>
                                    {['Malinha entregue', 'Entregue'].includes(
                                      sale?.status_text
                                    ) &&
                                    sale?.delivery?.status === DELIVERED ? (
                                      <>
                                        {
                                          sale?.return_delivery_address
                                            ?.street_name
                                        }
                                        ,{' '}
                                        {sale?.return_delivery_address?.number}{' '}
                                        -{' '}
                                        {
                                          sale?.return_delivery_address
                                            ?.neighborhood
                                        }
                                        , {sale?.return_delivery_address?.city}{' '}
                                        - {sale?.return_delivery_address?.state}
                                        , CEP{' '}
                                        {sale?.return_delivery_address?.cep}
                                      </>
                                    ) : (
                                      <>
                                        {sale?.store?.address?.street_name},{' '}
                                        {sale?.store?.address?.number} -{' '}
                                        {sale?.store?.address?.neighborhood},{' '}
                                        {sale?.store?.address?.city} -{' '}
                                        {sale?.store?.address?.state}, CEP{' '}
                                        {sale?.store?.address?.cep}
                                      </>
                                    )}
                                  </Col>
                                  <Col className="mx-0 pl-0" lg={3}>
                                    <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                      Endereço de entrega
                                    </p>
                                    {['Malinha entregue', 'Entregue'].includes(
                                      sale?.status_text
                                    ) &&
                                    sale?.delivery?.status === DELIVERED ? (
                                      <>
                                        {
                                          sale?.return_store?.address
                                            ?.street_name
                                        }
                                        , {sale?.return_store?.address?.number}{' '}
                                        -{' '}
                                        {
                                          sale?.return_store?.address
                                            ?.neighborhood
                                        }
                                        , {sale?.return_store?.address?.city} -{' '}
                                        {sale?.return_store?.address?.state},
                                        CEP {sale?.return_store?.address?.cep}
                                      </>
                                    ) : (
                                      <>
                                        {sale?.delivery_address?.street_name},{' '}
                                        {sale?.delivery_address?.number} -{' '}
                                        {sale?.delivery_address?.neighborhood},{' '}
                                        {sale?.delivery_address?.city} -{' '}
                                        {sale?.delivery_address?.state}, CEP{' '}
                                        {sale?.delivery_address?.cep}
                                      </>
                                    )}
                                  </Col>
                                  {sale?.delivery && (
                                    <Col className="mx-0 pl-0" xs={6} lg={3}>
                                      <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                        Situação da entrega
                                      </p>
                                      <span
                                        className={`font-weight-600 ${defineDeliveryStatusColor(
                                          [
                                            'Malinha entregue',
                                            'Entregue',
                                          ].includes(sale?.status_text) &&
                                            sale?.return_delivery
                                            ? sale?.return_delivery?.status_text
                                            : sale?.delivery?.status_text
                                        )}`}
                                      >
                                        {[
                                          'Malinha entregue',
                                          'Entregue',
                                        ].includes(sale?.status_text) &&
                                        sale?.return_delivery
                                          ? sale?.return_delivery?.status_text
                                          : sale?.delivery?.status_text}
                                      </span>
                                    </Col>
                                  )}
                                  <Col className="mx-0 pl-0" xs={6} lg={3}>
                                    <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                      Transportadora
                                    </p>
                                    {getFleetLabel(
                                      sale?.return_delivery_method ||
                                        sale?.delivery_method
                                    )}
                                  </Col>
                                  <Col className="mx-0 pl-0" xs={6} lg={3}>
                                    <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                      Veículo
                                    </p>
                                    {['Malinha entregue', 'Entregue'].includes(
                                      sale?.status_text
                                    ) && sale?.return_delivery ? (
                                      <>
                                        {getDeliveryVehicleLabel(
                                          sale?.return_delivery_vehicle
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {getDeliveryVehicleLabel(
                                          sale?.delivery_vehicle
                                        )}
                                      </>
                                    )}
                                  </Col>
                                  {(sale?.status >= 7 || sale?.status === 4) &&
                                  sale?.return_delivery?.status !== SEARCHING &&
                                  sale?.return_delivery?.worker_name ? (
                                    <>
                                      <Col className="mx-0 pl-0" xs={6} lg={3}>
                                        <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                          Nome do entregador
                                        </p>
                                        {capitalize(
                                          sale?.return_delivery?.worker_name
                                        )}
                                      </Col>
                                      {sale?.return_delivery?.worker_phone && (
                                        <Col
                                          className="mx-0 pl-0"
                                          xs={6}
                                          lg={3}
                                        >
                                          <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                            Tel do entregador
                                          </p>
                                          {formatPhone(
                                            sale?.return_delivery?.worker_phone
                                          )}
                                        </Col>
                                      )}
                                    </>
                                  ) : null}
                                  {sale?.status < 7 &&
                                  sale?.status !== 4 &&
                                  sale?.delivery?.status !== SEARCHING &&
                                  sale?.delivery?.worker_name ? (
                                    <>
                                      <Col className="mx-0 pl-0" xs={6} lg={3}>
                                        <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                          Nome do entregador
                                        </p>
                                        {capitalize(
                                          sale?.delivery?.worker_name
                                        )}
                                      </Col>
                                      {sale?.delivery?.worker_phone && (
                                        <Col
                                          className="mx-0 pl-0"
                                          xs={6}
                                          lg={3}
                                        >
                                          <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                            Tel do entregador
                                          </p>
                                          {formatPhone(
                                            sale?.delivery?.worker_phone
                                          )}
                                        </Col>
                                      )}
                                    </>
                                  ) : null}
                                  {sale?.delivery_method === 'UBER' ||
                                  sale?.return_delivery_method === 'UBER' ? (
                                    <Col className="mx-0 pl-0" xs={6} lg={3}>
                                      <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                        Uber ID
                                      </p>
                                      {(sale?.return_delivery
                                        ? sale?.return_delivery?.uber_uuid ||
                                          '-'
                                        : sale?.delivery?.uber_uuid) || '-'}
                                    </Col>
                                  ) : (
                                    <Col className="mx-0 pl-0" xs={6} lg={3}>
                                      <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                        ID da entrega
                                      </p>
                                      {(sale?.return_delivery
                                        ? sale?.return_delivery
                                            ?.id_on_service || '-'
                                        : sale?.delivery?.id_on_service) || '-'}
                                    </Col>
                                  )}
                                  {sale?.delivery_router?.current_incentive >
                                    0 && (
                                    <Col className="mx-0 pl-0" xs={6} lg={3}>
                                      <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                        Incentivo aplicado
                                      </p>
                                      <span className="text-green">
                                        {formatPrice(
                                          sale.delivery_router.current_incentive
                                        )}
                                      </span>
                                      {sale.delivery_router.retry_index > 0 && (
                                        <span className="text-gray-600">
                                          {' '}
                                          · {sale.delivery_router.retry_index}ª
                                          rebusca
                                        </span>
                                      )}
                                    </Col>
                                  )}
                                  {sale?.return_delivery &&
                                    sale?.return_delivery?.status !==
                                      SEARCHING &&
                                    sale?.return_delivery?.pickup_code && (
                                      <Col xs={6} lg={3} className="mx-0 pl-0">
                                        <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                          Código de coleta
                                        </p>
                                        {sale?.return_delivery?.pickup_code}
                                      </Col>
                                    )}
                                  {sale?.return_delivery &&
                                    sale?.return_delivery?.status !==
                                      SEARCHING &&
                                    sale?.return_delivery?.return_code && (
                                      <Col xs={6} lg={3} className="mx-0 pl-0">
                                        <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                          Código de retorno
                                        </p>
                                        {sale?.return_delivery?.return_code}
                                      </Col>
                                    )}
                                  {!sale?.return_delivery &&
                                    sale?.delivery?.status !== SEARCHING &&
                                    sale?.delivery?.pickup_code && (
                                      <Col xs={6} lg={3} className="mx-0 pl-0">
                                        <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                          Código de coleta
                                        </p>
                                        {sale?.delivery?.pickup_code}
                                      </Col>
                                    )}
                                  {!sale?.return_delivery &&
                                    sale?.delivery?.status !== SEARCHING &&
                                    sale?.delivery?.return_code && (
                                      <Col xs={6} lg={3} className="mx-0 pl-0">
                                        <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                          {sale?.delivery?.status ===
                                            RETURNING_TO_STORE ||
                                          sale?.delivery?.status ===
                                            RETURNED_TO_STORE
                                            ? 'Código de retorno — informe ao entregador'
                                            : 'Código de retorno'}
                                        </p>
                                        {sale?.delivery?.return_code}
                                      </Col>
                                    )}
                                </Row>

                                {!sale?.return_delivery &&
                                  sale?.delivery &&
                                  sale.delivery?.cancellation_reason && (
                                    <Col
                                      xs={6}
                                      className="px-0 mb-2 mb-lg-0 mt-2"
                                    >
                                      <div className="font-size-14 font-weight-600 text-gray-600 d-block">
                                        Motivo do Cancelamento
                                      </div>
                                      <div className="font-size-14 font-weight-400 d-block">
                                        {sale.delivery?.cancellation_reason}
                                      </div>
                                    </Col>
                                  )}
                                {sale?.return_delivery &&
                                  sale.return_delivery?.cancellation_reason && (
                                    <Col
                                      xs={6}
                                      className="px-0 mb-2 mb-lg-0 mt-2"
                                    >
                                      <div className="font-size-14 font-weight-600 text-gray-600 d-block">
                                        Motivo do Cancelamento
                                      </div>
                                      <div className="font-size-14 font-weight-400 d-block">
                                        {
                                          sale.return_delivery
                                            ?.cancellation_reason
                                        }
                                      </div>
                                    </Col>
                                  )}
                                {!sale?.is_suitcase_delivery &&
                                  !sale?.return_delivery &&
                                  sale?.delivery_score?.score && (
                                    <Col
                                      xs={6}
                                      lg={3}
                                      className="px-0 mb-2 mb-lg-0 mt-3"
                                    >
                                      <div className="font-size-14 font-weight-600 text-gray-600 d-block">
                                        Avaliação de entrega
                                      </div>
                                      <div className="font-size-14 font-weight-400 d-block mt-1">
                                        {Array(sale?.delivery_score?.score)
                                          .fill(1)
                                          .map((_, i) => (
                                            <FaStar
                                              // eslint-disable-next-line react/no-array-index-key
                                              key={`${sale?.delivery_score?.user_name}${i}`}
                                              color="#ffd600"
                                              size={30}
                                            />
                                          ))}
                                        {Array(5 - sale?.delivery_score?.score)
                                          .fill(1)
                                          .map((_, i) => (
                                            <FaRegStar
                                              // eslint-disable-next-line react/no-array-index-key
                                              key={`${sale?.delivery_score?.user_name}${i}`}
                                              color="#2544b1"
                                              size={30}
                                            />
                                          ))}
                                      </div>
                                    </Col>
                                  )}
                                {!sale?.is_suitcase_delivery &&
                                  sale?.return_delivery_score?.score && (
                                    <Col
                                      xs={6}
                                      lg={3}
                                      className="px-0 mb-2 mb-lg-0 mt-3"
                                    >
                                      <div className="font-size-14 font-weight-600 text-gray-600 d-block">
                                        Avaliação de entrega
                                      </div>
                                      <div className="font-size-14 font-weight-400 d-block mt-1">
                                        {Array(
                                          sale?.return_delivery_score?.score
                                        )
                                          .fill(1)
                                          .map((_, i) => (
                                            <FaStar
                                              // eslint-disable-next-line react/no-array-index-key
                                              key={`${sale?.return_delivery_score?.user_name}${i}`}
                                              color="#ffd600"
                                              size={30}
                                            />
                                          ))}
                                        {Array(
                                          5 - sale?.return_delivery_score?.score
                                        )
                                          .fill(1)
                                          .map((_, i) => (
                                            <FaRegStar
                                              // eslint-disable-next-line react/no-array-index-key
                                              key={`${sale?.return_delivery_score?.user_name}${i}`}
                                              color="#2544b1"
                                              size={30}
                                            />
                                          ))}
                                      </div>
                                    </Col>
                                  )}
                                {((!sale?.return_delivery &&
                                  sale?.delivery?.status !== DELIVERED) ||
                                  (sale?.return_delivery &&
                                    sale?.return_delivery?.status !==
                                      DELIVERED)) && (
                                  <Row className="mx-0 mb-0">
                                    <Col className="mx-0 px-0">
                                      <p className="font-size-14 font-weight-600 text-gray-600 mx-0 mt-2 mb-0">
                                        Link de rastreio
                                      </p>
                                      {!sale.return_delivery && (
                                        <>
                                          {sale?.delivery?.track_data ? (
                                            <a
                                              href={sale?.delivery?.track_data}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="text-black"
                                              id="deliveryTrackUrl"
                                            >
                                              {sale?.delivery?.track_data}
                                            </a>
                                          ) : (
                                            'Ainda não foi gerado um link de rastreio'
                                          )}
                                        </>
                                      )}
                                      {sale.return_delivery && (
                                        <>
                                          {sale?.return_delivery?.track_data ? (
                                            <a
                                              href={
                                                sale?.return_delivery
                                                  ?.track_data
                                              }
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="text-black"
                                              id="deliveryTrackUrl"
                                            >
                                              {
                                                sale?.return_delivery
                                                  ?.track_data
                                              }
                                            </a>
                                          ) : (
                                            'Ainda não foi gerado um link de rastreio'
                                          )}
                                        </>
                                      )}
                                    </Col>
                                  </Row>
                                )}
                                {(sale?.status === 4 || sale?.status >= 7) &&
                                  sale?.return_delivery?.track_data && (
                                    <Row className="mx-0 mt-3 mb-0">
                                      <div className="mx-0 px-0">
                                        <a
                                          target="_blank"
                                          rel="noreferrer"
                                          href={
                                            sale?.return_delivery?.worker_name
                                              ? `
                                https://wa.me/${formatWhatsappPhoneNumber(
                                  sale?.client?.telephone
                                )}?text=O entregador ${capitalize(
                                                  sale?.return_delivery
                                                    ?.worker_name
                                                )} aceitou sua corrida. Segue o link para rastreio ${
                                                  sale?.return_delivery
                                                    ?.track_data
                                                }
                              `
                                              : `
                                https://wa.me/${formatWhatsappPhoneNumber(
                                  sale?.client?.telephone
                                )}?text=Acabei de chamar o entregador para coletar o seu pedido, vamos aguardar alguém aceitar a corrida. Assim que tiver informações do entregador, compartilho aqui!
                              `
                                          }
                                        >
                                          <Button
                                            id="shareTrackURL"
                                            color="info"
                                            className="new-layout-btn main d-flex align-items-center bg-light-blue border-0 text-primary"
                                            outline
                                          >
                                            <i className="las la-share mr-2" />
                                            <span className="font-size-14">
                                              Compartilhar
                                            </span>
                                          </Button>
                                        </a>
                                      </div>
                                      <div className="mx-0 px-0 ml-auto ml-lg-4">
                                        <Button
                                          id="copyTrackURL"
                                          color="info"
                                          onClick={() => {
                                            const dummy =
                                              document.createElement(
                                                'textarea'
                                              );
                                            document.body.appendChild(dummy);
                                            dummy.value =
                                              sale?.return_delivery?.track_data;
                                            dummy.select();
                                            document.execCommand('copy');
                                            document.body.removeChild(dummy);

                                            toast.success('Link copiado!');
                                          }}
                                          className="new-layout-btn main d-flex align-items-center bg-light-blue border-0 text-primary"
                                          outline
                                        >
                                          <i className="las la-copy mr-2" />
                                          <span className="font-size-14">
                                            Copiar Link
                                          </span>
                                        </Button>
                                      </div>
                                    </Row>
                                  )}
                                {sale?.status < 7 &&
                                  sale?.delivery?.status !== DELIVERED &&
                                  sale?.delivery?.track_data &&
                                  !sale?.return_delivery && (
                                    <Row className="mx-0 mt-3 mb-0">
                                      <div className="mx-0 px-0">
                                        <a
                                          target="_blank"
                                          rel="noreferrer"
                                          href={
                                            sale?.delivery?.worker_name
                                              ? `
                                https://wa.me/${formatWhatsappPhoneNumber(
                                  sale?.client?.telephone
                                )}?text=O entregador ${capitalize(
                                                  sale?.delivery?.worker_name
                                                )} aceitou sua corrida. Segue o link para rastreio ${
                                                  sale?.delivery?.track_data
                                                }
                              `
                                              : `
                                https://wa.me/${formatWhatsappPhoneNumber(
                                  sale?.client?.telephone
                                )}?text=Acabei de chamar o entregador para coletar o seu pedido, vamos aguardar alguém aceitar a corrida. Assim que tiver informações do entregador, compartilho aqui!
                              `
                                          }
                                        >
                                          <Button
                                            id="shareTrackURL"
                                            color="info"
                                            className="new-layout-btn main d-flex align-items-center bg-light-blue border-0 text-primary"
                                            outline
                                          >
                                            <i className="las la-share mr-2" />
                                            <span className="font-size-14">
                                              Compartilhar
                                            </span>
                                          </Button>
                                        </a>
                                      </div>
                                      <div className="mx-0 px-0 ml-4">
                                        <Button
                                          id="copyTrackURL"
                                          color="info"
                                          onClick={() => {
                                            const dummy =
                                              document.createElement(
                                                'textarea'
                                              );
                                            document.body.appendChild(dummy);
                                            dummy.value =
                                              sale?.delivery?.track_data;
                                            dummy.select();
                                            document.execCommand('copy');
                                            document.body.removeChild(dummy);

                                            toast.success('Link copiado!');
                                          }}
                                          className="new-layout-btn main d-flex align-items-center bg-light-blue border-0 text-primary"
                                          outline
                                        >
                                          <i className="las la-copy mr-2" />
                                          <span className="font-size-14">
                                            Copiar
                                          </span>
                                        </Button>
                                      </div>
                                    </Row>
                                  )}

                                {sale?.delivery?.qr_code && (
                                  <Row className="mx-0 mb-0">
                                    <Col
                                      xs={12}
                                      lg={12}
                                      className="pl-0 mt-3 ml-lg-1 pr-lg-2"
                                    >
                                      <DeliveryQrcode
                                        qrCode={sale?.delivery?.qr_code}
                                        sale={sale}
                                      />
                                    </Col>
                                  </Row>
                                )}

                                {sale?.return_delivery &&
                                  sale?.return_delivery?.status === SEARCHING &&
                                  sale?.return_delivery?.status ===
                                    GOING_TO_STORE &&
                                  sale?.return_delivery?.status ===
                                    ARRIVED_AT_STORE && (
                                    <hr className="d-flex ml-0 ml-lg-2 mr-lg-4 mb-2" />
                                  )}

                                <Row className="mx-0 mt-4 mb-0 justify-content-end">
                                  {/* ((!sale?.return_delivery &&
                                      sale?.delivery?.status !== SEARCHING &&
                                      sale?.delivery?.status !== DELIVERED) ||
                                      (sale?.return_delivery &&
                                        sale?.return_delivery?.status !==
                                          SEARCHING &&
                                        sale?.return_delivery?.status !==
                                          DELIVERED)) && (
                                      <Col
                                        xs={12}
                                        sm={4}
                                        className="px-0 pr-sm-2"
                                      >
                                        <Button
                                          color="info"
                                          className="new-layout-btn main mb-2 mr-lg-2 w-100"
                                          onClick={handleResetDelivery}
                                          outline
                                        >
                                          Reiniciar entrega
                                        </Button>
                                      </Col>
                                    ) */}
                                  {((!sale?.return_delivery &&
                                    (sale?.delivery?.status ===
                                      GOING_TO_STORE ||
                                      sale?.delivery?.status ===
                                        ARRIVED_AT_STORE ||
                                      sale?.delivery?.status === CANCELLED)) ||
                                    (sale?.return_delivery &&
                                      (sale?.return_delivery?.status ===
                                        GOING_TO_CLIENT ||
                                        sale?.return_delivery?.status ===
                                          ARRIVED_AT_CLIENT ||
                                        sale?.return_delivery?.status ===
                                          CANCELLED))) &&
                                    !hideButtonSaleCross && (
                                      <Col
                                        xs={12}
                                        sm={5}
                                        className="px-0 px-lg-2"
                                      >
                                        <Button
                                          color="info"
                                          className="relative new-layout-btn main mb-2 mr-lg-2 w-100"
                                          onClick={handleRetryDeliveryNow}
                                          disabled={
                                            shouldDisableDeliveryForceRetry
                                          }
                                          outline
                                        >
                                          <span
                                            style={{
                                              marginRight:
                                                shouldDisableDeliveryForceRetry
                                                  ? '1.5rem'
                                                  : undefined,
                                            }}
                                          >
                                            Nova tentativa de entrega{' '}
                                          </span>
                                          {shouldDisableDeliveryForceRetry && (
                                            <TimerDisplay
                                              timestamp={
                                                dateNow - lastDeliveryForceRetry
                                              }
                                              totalTime={COOLDOWN_MS}
                                            />
                                          )}
                                        </Button>
                                      </Col>
                                    )}
                                  {sale?.delivery_router &&
                                    isSupport &&
                                    (sale?.delivery?.status === SEARCHING ||
                                      sale?.delivery?.status === CANCELLED ||
                                      sale?.delivery_router?.status ===
                                        'EXHAUSTED') &&
                                    !hideButtonSaleCross && (
                                      <Col
                                        xs={12}
                                        sm={4}
                                        className="px-0 px-lg-2"
                                      >
                                        <Button
                                          color="primary"
                                          className="new-layout-btn main mb-2 mr-lg-2 w-100"
                                          onClick={() =>
                                            setShowChangeCarrier(true)
                                          }
                                          outline
                                        >
                                          Trocar transportadora
                                        </Button>
                                      </Col>
                                    )}

                                  {sale?.delivery_router?.can_boost &&
                                    isSupport &&
                                    !hideButtonSaleCross && (
                                      <Col
                                        xs={12}
                                        sm={4}
                                        className="px-0 px-lg-2"
                                      >
                                        <Button
                                          color="primary"
                                          className="new-layout-btn main mb-2 mr-lg-2 w-100"
                                          onClick={() =>
                                            setShowBoostIncentive(true)
                                          }
                                          outline
                                        >
                                          Aumentar incentivo
                                        </Button>
                                      </Col>
                                    )}
                                  {((!sale?.return_delivery &&
                                    (sale?.delivery?.status === SEARCHING ||
                                      sale?.delivery?.status ===
                                        GOING_TO_STORE ||
                                      sale?.delivery?.status ===
                                        ARRIVED_AT_STORE)) ||
                                    (sale?.return_delivery &&
                                      (sale?.return_delivery?.status ===
                                        SEARCHING ||
                                        sale?.return_delivery?.status ===
                                          GOING_TO_CLIENT ||
                                        sale?.return_delivery?.status ===
                                          ARRIVED_AT_CLIENT))) &&
                                    !hideButtonSaleCross && (
                                      <Col
                                        xs={12}
                                        sm={4}
                                        className="pl-sm-2 px-0"
                                      >
                                        <Button
                                          color="danger"
                                          className="new-layout-btn main mb-2 mr-lg-2 w-100"
                                          onClick={toggleCancelDelivery}
                                          outline
                                        >
                                          Cancelar Entrega
                                        </Button>
                                      </Col>
                                    )}
                                </Row>
                              </Collapse>
                            </CardBody>
                          </Card>
                        )}
                    </>
                  )}
                  {sale?.status_text ===
                    'Pagamento rejeitado pelo adquirente' ||
                  sale?.status_text === 'Em pagamento' ||
                  (sale?.status_text === 'Coleta realizada' &&
                    sale?.amount !== '0.00') ||
                  sale?.status_text ===
                    'Pagamento rejeitado automaticamente pelo serviço' ? (
                    <PaymentCard cart={sale} />
                  ) : null}
                  <div className="d-lg-none">
                    {subscriberId !== subscriberViddyComercial && (
                      <>
                        <AntifraudViddyCard cart={sale} />
                        <AntifraudInfoCard cart={sale} />
                        <PaymentInfoCard cart={sale} />
                        <BillingInfoCard cart={sale} />
                      </>
                    )}
                    <ApiOriginInfoCard cart={sale} />
                    <WhatsappTimeline
                      cartId={sale.id}
                      hasWhatsappFlow={sale?.has_whatsapp_flow}
                    />
                    <ColectInfoCard cart={sale} />
                    <DeliveryInfoCard cart={sale} />
                    <DeliveryHistoryCard
                      saleId={sale?.id}
                      role={role}
                      isForDelivery={sale?.is_for_delivery}
                    />
                    <PickupValidationCard cart={sale} />
                    <CorreiosInfoCard cart={sale} />
                    <CorreiosReverseInfoCard reverse={correiosReverse} />
                    {sale?.is_for_delivery && sale?.delivery && (
                      <>
                        <PickupValidationAlert
                          deliveryStatus={delivery?.status}
                          featureEnabled={pickupValidationEnabled}
                          cartValidation={sale?.delivery?.pickup_validation}
                          cartId={sale?.id}
                        />
                        <PickupValidationModal cartId={sale?.id} />
                      </>
                    )}
                  </div>
                  <Row className="w-100 mx-0">
                    <Col className="px-0">
                      <CartMainInfoCard
                        cart={sale}
                        setData={setData}
                        setProductsData={setProductsData}
                        shareableURL={shareableURL}
                      />
                    </Col>
                  </Row>
                  <Row className="w-100 mx-0">
                    <Col className="px-0">
                      <CustomerDataCard cart={sale} customer={client} />
                    </Col>
                  </Row>
                  {subscriberId !== subscriberViddyComercial && (
                    <Row className="w-100 mx-0 d-none d-lg-flex">
                      <Col className="px-0">
                        {sale.products.length > 0 && (
                          <ProductsListCard products={sale.products} />
                        )}
                        {/* <TaxCuponsCard
                        cart={sale}
                        handleUploadTaxCoupon={handleUploadTaxCoupon}
                      /> */}
                        {!hideButtonSaleCross && (
                          <CuponsNumberCard
                            cart={sale}
                            formRef={cuponsformRef}
                            handle={handleAddCuponsNumber}
                            onInvoiceKeySaved={loadSale}
                            invoiceKeyFocusRequest={invoiceKeyFocusRequest}
                          />
                        )}
                        <LossCheckboxCard sale={sale} hadLoss={sale.had_loss} />
                      </Col>
                    </Row>
                  )}
                </Col>
                <Col lg={showSidebar ? 4 : 5} className="px-0 pl-lg-3">
                  <Row className="w-100 mx-0 d-none d-lg-flex">
                    <Col className="px-0">
                      <SaleStatusBadge
                        cart={sale}
                        cartDetails
                        extraClass="mb-0"
                      />
                    </Col>
                  </Row>
                  <FinalValueCard cart={sale} />
                  <WhatsappTimeline
                    cartId={sale.id}
                    hasWhatsappFlow={sale?.has_whatsapp_flow}
                  />
                  <div className="d-none d-lg-block">
                    {subscriberId !== subscriberViddyComercial && (
                      <>
                        <AntifraudViddyCard cart={sale} />
                        <AntifraudInfoCard cart={sale} />
                        <PaymentInfoCard cart={sale} />
                        <BillingInfoCard cart={sale} />
                      </>
                    )}
                    <ApiOriginInfoCard cart={sale} />
                    <ColectInfoCard cart={sale} />
                    <DeliveryInfoCard cart={sale} />
                    <DeliveryHistoryCard
                      saleId={sale?.id}
                      role={role}
                      isForDelivery={sale?.is_for_delivery}
                    />
                    <PickupValidationCard cart={sale} />
                    <CorreiosInfoCard cart={sale} />
                    <CorreiosReverseInfoCard reverse={correiosReverse} />
                  </div>
                  {subscriberId !== subscriberViddyComercial && (
                    <div className="px-0 d-lg-none">
                      {sale.products.length > 0 && (
                        <ProductsListCard products={products} />
                      )}
                      {/* <TaxCuponsCard
                      cart={sale}
                      handleUploadTaxCoupon={handleUploadTaxCoupon}
                    /> */}
                      {!hideButtonSaleCross && (
                        <CuponsNumberCard
                          cart={sale}
                          formRef={cuponsformRef}
                          handle={handleAddCuponsNumber}
                          onInvoiceKeySaved={loadSale}
                          invoiceKeyFocusRequest={invoiceKeyFocusRequest}
                        />
                      )}
                    </div>
                  )}
                  {/* {showGiftBoxesCard && <GiftBoxesCard products={products} />} */}
                </Col>
              </Row>
              {showButtons && (
                <Col lg={9} className="px-0">
                  <CartManagementButtons
                    cart={sale}
                    setData={setData}
                    setProductsData={setProductsData}
                  />
                </Col>
              )}
            </>
          )}
        </Container>

        {/* {delivery && (
        <Modal
          isOpen={isRetryDeliveryModalOpen}
          toggle={toggleRetryDelivery}
          scrollable
        >
          <ModalHeader toggle={toggleRetryDelivery}>
            Nova tentativa de Entrega
          </ModalHeader>

          <ModalBody>
            <h5>
              Deseja realizar uma nova tentativa de entrega para o pedido #
              <strong>{sale?.order_number}</strong>?
            </h5>
            <h5>Nova tentativa agora?</h5>
            <CustomInput
              type="switch"
              id="deliveryNow"
              name="deliveryNow"
              label="Nova tentativa de entrega agora"
              checked={deliveryNow}
              className="text-primary z-index-0"
              onChange={() => setDeliveryNow(!deliveryNow)}
            />

            {!deliveryNow && (
              <Row className="w-100 mx-0 mt-2">
                Para nova tentativa, tempo mínimo de 35 minutos a partir de
                agora.
                <Col lg={6} className="px-0 pr-lg-2 mb-2 mb-lg-0">
                  <DatePicker
                    value={scheduledDeliveryDate}
                    onChange={selectedDate =>
                      setScheduledDeliveryDate(selectedDate)
                    }
                    mask="__/__/___"
                    placeholder="Dia"
                    disablePast
                  />
                </Col>
                <Col lg={6} className="px-0 pl-lg-2">
                  <TimePicker
                    value={scheduledDeliveryTime}
                    onChange={selectedTime =>
                      setScheduledDeliveryTime(selectedTime)
                    }
                    mask="__:__ _M"
                    placeholder="Horário"
                  />
                </Col>
              </Row>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() =>
                deliveryNow ? handleRetryDeliveryNow() : handleRetryDelivery()
              }
            >
              Confirmar
            </Button>
          </ModalFooter>
        </Modal>
      )} */}

        <ChangeCarrierModal
          isOpen={showChangeCarrier}
          toggle={() => setShowChangeCarrier(false)}
          saleId={sale?.id}
          role={role}
          onSuccess={() => window.location.reload()}
        />

        <BoostIncentiveModal
          isOpen={showBoostIncentive}
          toggle={() => setShowBoostIncentive(false)}
          saleId={sale?.id}
          role={role}
          currentIncentive={sale?.delivery_router?.current_incentive}
          minimumIncentive={sale?.delivery_router?.minimum_incentive}
          operatorLabel={sale?.delivery_router?.current_operator}
          onSuccess={() => window.location.reload()}
        />

        {delivery && (
          <Modal
            isOpen={isCancelDeliveryModalOpen}
            toggle={toggleCancelDelivery}
            scrollable
          >
            <ModalHeader toggle={toggleCancelDelivery}>
              Cancelar Entrega
            </ModalHeader>

            <Form onSubmit={handleCancelDelivery} ref={formRef}>
              <ModalBody>
                <h5>
                  A entrega do pedido #<strong>{sale?.order_number}</strong>{' '}
                  será cancelada.
                </h5>
                <FormGroup className="mt-3 mb-0">
                  <Input
                    name="reason"
                    placeholder="Motivo do cancelamento"
                    type="text"
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  className="new-layout-btn main"
                  type="submit"
                  color="danger"
                >
                  Confirmar
                </Button>
              </ModalFooter>
            </Form>
          </Modal>
        )}

        {delivery && (
          <Modal
            isOpen={isFinishCancelledOrderModalOpen}
            toggle={toggleFinishCancelledOrder}
          >
            <ModalHeader toggle={toggleFinishCancelledOrder}>
              Marcar o pedido como entregue
            </ModalHeader>

            <Form onSubmit={handleFinishCancelledOrder} ref={formRef}>
              <ModalBody>
                <h6>
                  <strong>Número do pedido: {sale?.order_number}.</strong>
                </h6>
                <h5>
                  O pedido de <strong>{sale?.client.name}</strong> será marcado
                  como finalizado mesmo tendo sua entrega cancelada.
                </h5>
                <FormGroup className="mt-3 mb-0">
                  <InputSelect
                    name="finalization_reason"
                    options={[
                      {
                        label: 'Entrega realizada por outro parceiro logístico',
                        value: 'Entrega realizada por outro parceiro logístico',
                      },
                      {
                        label: 'O pedido não foi entregue',
                        value: 'O pedido não foi entregue',
                      },
                      {
                        label: 'O cliente decidiu retirar em loja',
                        value: 'O cliente decidiu retirar em loja',
                      },
                      {
                        label: 'Outros',
                        value: 'Outros',
                      },
                    ]}
                    isSearchable
                    placeholder="Motivo"
                    type="text"
                    styles={{
                      control: base => ({ ...base, height: '39px' }),
                    }}
                  />
                </FormGroup>
                <FormGroup className="mt-3 mb-0">
                  <Input
                    name="finalization_details"
                    placeholder="Descrição detalhada"
                    type="text"
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  onClick={() => setIsFinishCancelledOrderModalOpen(false)}
                  color="secondary"
                >
                  Sair
                </Button>
                <Button type="submit" color="success">
                  Confirmar
                </Button>
              </ModalFooter>
            </Form>
          </Modal>
        )}

        {sale?.delivery_method === 'CORREIOS' && (
          <Modal
            isOpen={isCorreiosLabelModalOpen}
            toggle={toggleCorreiosLabelModal}
          >
            <ModalHeader toggle={toggleCorreiosLabelModal}>
              Pré Postagem e Gerar Etiqueta
            </ModalHeader>

            <ModalBody>
              {/* ─── ESTADO: IDLE ─── */}
              {labelStatus === 'idle' && !isGeneratingLabel && (
                <>
                  {isPrePostagemCanceled && delivery?.cancellation_reason && (
                    <div
                      className="border rounded p-2 mb-3 font-size-13"
                      style={{
                        background: '#FEF3C7',
                        borderColor: '#FDE68A',
                        color: '#92400E',
                      }}
                    >
                      A pré-postagem anterior foi cancelada:{' '}
                      {delivery.cancellation_reason}
                    </div>
                  )}

                  <p className="mb-3">
                    Ao confirmar, vamos registrar a{' '}
                    <strong>pré-postagem</strong> deste pedido nos Correios e
                    gerar o <strong>rótulo (etiqueta)</strong> em PDF.
                  </p>

                  <p className="mb-3 font-size-13 text-muted">
                    {invoiceKey
                      ? `Documento fiscal: nota nº ${
                          sale?.nfce?.number || ''
                        } (chave informada).`
                      : 'Sem chave da nota: a pré-postagem será feita com Declaração de Conteúdo (DC-e).'}
                  </p>

                  <p className="mb-2 font-weight-600">
                    O que vai acontecer agora:
                  </p>
                  <ul className="pl-3 mb-3">
                    <li>
                      O sistema vai gerar a etiqueta com remetente e
                      destinatário;
                    </li>
                    <li>
                      Você deverá baixar e imprimir a etiqueta de entrega.
                    </li>
                    {invoiceKey ? (
                      <li>
                        Leve a DANFE ou o cupom da nota fiscal junto ao produto
                        aos Correios.
                      </li>
                    ) : (
                      <>
                        <li>
                          Você deverá baixar e imprimir a declaração de
                          conteúdo.
                        </li>
                        <li>
                          Leve a declaração de conteúdo junto ao produto ao
                          correios.
                        </li>
                      </>
                    )}
                  </ul>

                  <p className="mb-2 font-weight-600">Importante:</p>
                  <ul className="pl-3 mb-0">
                    <li>
                      A pré-postagem <strong>não conclui o envio</strong>. Você
                      ainda precisa levar o pacote a uma agência dos Correios
                      para finalizar a postagem.
                    </li>
                    <li>
                      Cole a etiqueta do lado externo da embalagem, em uma área
                      lisa e sem dobras.
                    </li>
                    <li>
                      Na agência, apresente o pacote já identificado e guarde o
                      comprovante de postagem.
                    </li>
                  </ul>
                </>
              )}

              {/* ─── ESTADO: GERANDO PRÉ-POSTAGEM ─── */}
              {isGeneratingLabel && (
                <div className="text-center py-4">
                  <i className="fas fa-spinner fa-spin font-size-24 text-primary mb-3 d-block" />
                  <p className="font-size-16 font-weight-600 mb-1">
                    Criando pré-postagem...
                  </p>
                  <p className="text-muted font-size-14 mb-0">
                    Registrando o envio nos Correios. Aguarde alguns segundos.
                  </p>
                </div>
              )}

              {/* ─── ESTADO: PENDING / PROCESSING ─── */}
              {!isGeneratingLabel &&
                (labelStatus === 'pending' || labelStatus === 'processing') && (
                  <div className="text-center py-4">
                    <i className="fas fa-spinner fa-spin font-size-24 text-primary mb-3 d-block" />
                    <p className="font-size-16 font-weight-600 mb-1">
                      Gerando etiqueta, aguarde...
                    </p>
                    <p className="text-muted font-size-14 mb-2">
                      A etiqueta está sendo processada pelos Correios. Isso pode
                      levar alguns instantes.
                    </p>

                    {labelTrackingCode && (
                      <div
                        className="mt-3 mx-auto py-2 px-3 d-inline-block"
                        style={{
                          border: '1px dashed #adb5bd',
                          borderRadius: '6px',
                        }}
                      >
                        <small
                          className="text-muted d-block"
                          style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                        >
                          CÓDIGO DE RASTREIO
                        </small>
                        <span className="font-size-16 font-weight-600 text-primary">
                          {labelTrackingCode}
                        </span>
                      </div>
                    )}

                    <p className="text-muted font-size-12 mt-3 mb-0">
                      Você pode fechar este modal. A etiqueta continuará sendo
                      processada.
                    </p>
                  </div>
                )}

              {/* ─── ESTADO: READY ─── */}
              {labelStatus === 'ready' && (
                <>
                  <div className="text-center mb-3">
                    <i
                      className="fas fa-check-circle font-size-36 mb-2 d-block"
                      style={{ color: '#34c38f' }}
                    />
                    <p className="font-size-16 font-weight-600 mb-1">
                      Etiqueta gerada com sucesso!
                    </p>
                  </div>

                  {labelTrackingCode && (
                    <div
                      className="text-center mb-3 mx-auto py-2 px-3 d-inline-block w-100"
                      style={{
                        border: '1px solid #34c38f',
                        borderRadius: '6px',
                        backgroundColor: 'rgba(52, 195, 143, 0.08)',
                      }}
                    >
                      <small
                        className="text-muted d-block"
                        style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                      >
                        CÓDIGO DE RASTREIO
                      </small>
                      <span
                        className="font-size-16 font-weight-600"
                        style={{ color: '#34c38f' }}
                      >
                        {labelTrackingCode}
                      </span>
                    </div>
                  )}

                  <p className="mb-2 font-weight-600">Próximos passos:</p>
                  <ul className="pl-3 mb-3">
                    <li>
                      Baixe o PDF e imprima a etiqueta em boa qualidade
                      (preferencialmente em folha branca).
                    </li>
                    <li>
                      Cole a etiqueta na parte externa do pacote, em uma área
                      lisa e bem visível.
                    </li>
                    <li>
                      {fiscalDocument === 'NFE'
                        ? 'Leve o pacote com a DANFE ou o cupom da nota fiscal para a agência dos Correios para concluir a postagem e receber o comprovante de envio.'
                        : 'Leve o pacote e a declaração de conteúdo para a agência dos correios para concluir a postagem e receber o comprovante de envio.'}
                    </li>
                  </ul>
                </>
              )}

              {/* ─── ESTADO: FAILED ─── */}
              {labelStatus === 'failed' && (
                <div className="text-center py-3">
                  <i className="fas fa-exclamation-triangle font-size-36 text-danger mb-2 d-block" />
                  <p className="font-size-16 font-weight-600 mb-2">
                    Não foi possível gerar a etiqueta
                  </p>
                  <p className="text-muted font-size-14 mb-3">
                    {labelError ||
                      'Ocorreu um erro ao processar o rótulo nos Correios. Tente novamente.'}
                  </p>

                  {labelTrackingCode && (
                    <div
                      className="mb-3 mx-auto py-2 px-3 d-inline-block"
                      style={{
                        border: '1px dashed #adb5bd',
                        borderRadius: '6px',
                      }}
                    >
                      <small
                        className="text-muted d-block"
                        style={{ fontSize: '11px', letterSpacing: '0.5px' }}
                      >
                        CÓDIGO DE RASTREIO
                      </small>
                      <span className="font-size-16 font-weight-600">
                        {labelTrackingCode}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </ModalBody>

            <ModalFooter>
              {labelStatus === 'idle' && !isGeneratingLabel && (
                <>
                  <Button
                    color="secondary"
                    className="new-layout-btn main"
                    onClick={toggleCorreiosLabelModal}
                  >
                    Cancelar
                  </Button>
                  <Button
                    color="primary"
                    className="new-layout-btn main"
                    onClick={handleGenerateCorreiosLabel}
                  >
                    Gerar Pré Postagem
                  </Button>
                </>
              )}

              {(isGeneratingLabel ||
                labelStatus === 'pending' ||
                labelStatus === 'processing') && (
                <Button
                  color="secondary"
                  className="new-layout-btn main"
                  onClick={toggleCorreiosLabelModal}
                >
                  Fechar
                </Button>
              )}

              {labelStatus === 'ready' && (
                <>
                  <Button
                    color="secondary"
                    className="new-layout-btn main"
                    onClick={toggleCorreiosLabelModal}
                  >
                    Fechar
                  </Button>
                  <Button
                    color="primary"
                    className="new-layout-btn main"
                    onClick={handleDownloadCorreiosLabel}
                  >
                    <i className="fas fa-download mr-2" />
                    Baixar Etiqueta (PDF)
                  </Button>
                </>
              )}

              {labelStatus === 'failed' && (
                <>
                  <Button
                    color="secondary"
                    className="new-layout-btn main"
                    onClick={toggleCorreiosLabelModal}
                  >
                    Fechar
                  </Button>
                  <Button
                    color="primary"
                    className="new-layout-btn main"
                    onClick={handleRetryLabel}
                    disabled={isRetryingLabel}
                  >
                    {isRetryingLabel ? (
                      <>
                        <i className="fas fa-spinner fa-spin mr-2" />
                        Reenviando...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-redo mr-2" />
                        Tentar Novamente
                      </>
                    )}
                  </Button>
                </>
              )}
            </ModalFooter>
          </Modal>
        )}
        {/*
        {sale?.delivery_method === 'CORREIOS' && (
          <Modal
            isOpen={isCorreiosDeclarationModalOpen}
            toggle={toggleCorreiosDeclarationModal}
            size="xl"
            className="modal-declaration"
          >
            <ModalHeader toggle={toggleCorreiosDeclarationModal}>
              Declaração de Conteúdo
            </ModalHeader>
            <ModalBody>
              <iframe
                id="declaration-frame"
                srcDoc={declarationHtml}
                title="Declaração de Conteúdo"
                sandbox="allow-modals allow-same-origin allow-scripts allow-popups allow-top-navigation-by-user-activation"
              />
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                className="new-layout-btn main"
                onClick={toggleCorreiosDeclarationModal}
              >
                Fechar
              </Button>
              <Button
                color="primary"
                className="new-layout-btn main"
                disabled={isDownloadingDeclaration}
                onClick={handlePrint}
              >
                Imprimir
              </Button>
            </ModalFooter>
          </Modal>
        )}
        */}

        <Modal
          isOpen={isDceWarningOpen}
          toggle={() => setIsDceWarningOpen(false)}
        >
          <ModalHeader toggle={() => setIsDceWarningOpen(false)}>
            Chave da nota fiscal não informada
          </ModalHeader>
          <ModalBody>
            <p className="mb-3">
              Sem a chave da nota fiscal, a pré-postagem é feita com{' '}
              <strong>Declaração de Conteúdo (DC-e)</strong>, que os Correios só
              aceitam para empresas <strong>não contribuintes de ICMS</strong>.
              Se a sua loja emite nota fiscal, a pré-postagem será cancelada
              pelos Correios.
            </p>
            <p className="mb-2 font-weight-600">Para usar a nota fiscal:</p>
            <ol className="pl-3 mb-0">
              <li>
                Clique em <strong>Informar chave</strong> abaixo;
              </li>
              <li>
                Digite os 44 dígitos, leia o QR Code / código de barras com a
                câmera ou importe o XML da nota;
              </li>
              <li>
                Clique em <strong>Salvar chave</strong> e depois em{' '}
                <strong>Pré Postagem</strong> novamente.
              </li>
            </ol>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              className="new-layout-btn main"
              onClick={() => {
                setIsDceWarningOpen(false);
                setInvoiceKeyFocusRequest(n => n + 1);
              }}
            >
              Informar chave
            </Button>
            <Button
              color="primary"
              className="new-layout-btn main"
              onClick={() => {
                setIsDceWarningOpen(false);
                toggleCorreiosLabelModal();
              }}
            >
              Continuar com DC-e
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={isNfeDeclarationInfoOpen}
          toggle={() => setIsNfeDeclarationInfoOpen(false)}
        >
          <ModalHeader toggle={() => setIsNfeDeclarationInfoOpen(false)}>
            Declaração de Conteúdo
          </ModalHeader>
          <ModalBody>
            <p className="mb-3">
              Esta pré-postagem foi registrada com a{' '}
              <strong>
                nota fiscal nº {delivery?.metadata?.fiscal?.number || ''}
              </strong>
              . Por isso não existe Declaração de Conteúdo (DC-e) para ela.
            </p>
            <p className="mb-0">
              O documento que acompanha o pacote é a{' '}
              <strong>DANFE ou o cupom da nota fiscal</strong>, junto com a
              etiqueta.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              className="new-layout-btn main"
              onClick={() => setIsNfeDeclarationInfoOpen(false)}
            >
              Entendi
            </Button>
          </ModalFooter>
        </Modal>

        <CorreiosReverseModal reverse={correiosReverse} sale={sale} />

        <RatingDeliveryModal
          setShouldReloadCart={setShouldReloadCart}
          showModal={showRatingModal}
          toggle={toggleRating}
          cart={sale}
        />

        <UnifyDeliveriesModal
          showModal={showUnifyDeliveriesModal}
          toggle={toggle}
          alerts={alerts}
          alertsLength={alertsLength}
          unifiableCarts={unifiableCarts}
          cartsToUnify={cartsToUnify}
          addCart={handleAddToUnifiedCarts}
          removeCart={handleRemoveFromUnifiedCarts}
          unifyDeliveries={handleUnifyDeliveries}
        />

        <ConfirmPickupModal
          isOpen={showConfirmationModal}
          toggle={() => {
            setShowConfirmationModal(false);
            setModalDismissedManually(true);
          }}
          confirmationCode={sale?.confirmation_code}
          saleId={sale?.id}
          role={role}
          onConfirmSuccess={loadSale}
        />
      </div>
    </>
  );
};

export default Sale;
